<template>
    <div 
        class="formfield formfield--select" 
        :class="{'formfield--error': (error)}">
        <label
            v-if="label"
            class="formfield__label">
            {{ label }}
            <span
                class="required"
                v-if="required">*</span>
        </label>

        <div class="formfield__input">
            <div
                class="customselect"
                :class="placeholderClass">
                <select 
                    ref="currentValue" 
                    @input="updateValue()"
                    @change="updateValue()" 
                    @focus="removeError" 
                    :value="value" 
                    :placeholder="placeholder">
                    <slot/>
                </select>
            </div>

            <div 
                class="formfield__error">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    $_veeValidate: {
        value () {
            return this.$refs.currentValue.value;
        }
    },
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        errors: {
            type: Object,
            default: null
        },
        required: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
        value: {
            default: null,
            type: String,
        },
    },
    computed: {
        error() {
            if (this.errors) {
                return this.errors.first(this.name);
            }

            return null;
        },
        placeholderClass() {
            if(!this.value) {
                return 'customselect--placeholder';
            }

            return '';
        }
    },
    methods: {
        removeError() {
            if (this.errors) {
                this.errors.remove(this.name);
            }
        },
        updateValue() {
            this.$emit('input', this.$refs.currentValue.value);
        },
    },
};
</script>
